// pages/SessionExpired.js
import React from "react";
import { Link } from "react-router-dom";

const SessionExpired = () => {
  return (
    <div className="h-screen flex items-center justify-center flex-col text-center p-4">
      <h1 className="text-2xl font-bold mb-4">Session Expired</h1>
      <p className="mb-6">Your session has expired. Please log in again.</p>
      <Link
        to="/auth/sign-in"
        className="bg-brand-500 text-white py-2 px-4 rounded hover:bg-brand-600"
      >
        Go to Login
      </Link>
    </div>
  );
};

export default SessionExpired;
